import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export interface InfoField {
  label: string;
  value: React.ReactNode;
  span?: boolean;
}

interface InfoCardProps {
  title?: string;
  fields: InfoField[];
  columns?: 2 | 3 | 4;
  className?: string;
}

export default function InfoCard({
  title,
  fields,
  columns = 2,
  className = '',
}: InfoCardProps) {
  const gridCols = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
  }[columns];

  return (
    <Card className={className}>
      {title && (
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-semibold">{title}</CardTitle>
        </CardHeader>
      )}
      <CardContent className={title ? 'pt-0' : 'pt-4'}>
        <dl className={`grid ${gridCols} gap-x-6 gap-y-4`}>
          {fields.map((field, idx) => (
            <div key={idx} className={field.span ? 'col-span-full' : ''}>
              <dt className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-0.5">
                {field.label}
              </dt>
              <dd className="text-sm font-medium text-foreground">
                {field.value ?? '—'}
              </dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
